export const riskTone = (score) => {
  if (score == null) return { color: 'var(--text-muted)',      labelKey: 'common.severity.none',     band: 'none'     };
  if (score >= 70)   return { color: 'var(--threat-critical)', labelKey: 'common.severity.critical', band: 'critical' };
  if (score >= 40)   return { color: 'var(--threat-high)',     labelKey: 'common.severity.high',     band: 'high'     };
  if (score >= 20)   return { color: 'var(--threat-medium)',   labelKey: 'common.severity.medium',   band: 'medium'   };
  return               { color: 'var(--threat-low)',           labelKey: 'common.severity.low',      band: 'low'      };
};

export const THREAT_FEED_TYPES = {
  MALWARE:    'var(--threat-critical)',
  PHISHING:   'var(--threat-high)',
  C2:         'var(--accent)',
  BOTNET:     'var(--threat-medium)',
  RANSOMWARE: 'var(--accent)',
  SPAM:       'var(--text-secondary)',
};
